import { render } from "./DefaultFieldset.vue?vue&type=template&id=192a0008"
import script from "./DefaultFieldset.vue?vue&type=script&lang=js"
export * from "./DefaultFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__